module.exports = __webpack_public_path__ + "img/title_bg.f37d73e0.png";